(() => {
  const root = document.querySelector('.embers-home');
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const revealGroups = [
    '.embers-section-head',
    '.embers-edition',
    '.embers-about__grid > *',
    '.embers-quote',
    '.embers-stat',
    '.embers-step',
    '.embers-newsletter__inner'
  ];

  const revealItems = root.querySelectorAll(revealGroups.join(','));
  revealItems.forEach((item, index) => {
    item.classList.add('embers-reveal');
    item.style.setProperty('--embers-reveal-delay', `${Math.min(index % 6, 5) * 80}ms`);
  });

  root.classList.add('embers-motion-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.16 }
  );

  revealItems.forEach((item) => observer.observe(item));
})();
